export default __webpack_public_path__ + "static/media/Stanford.d60ffa96.png";